module.exports = __webpack_public_path__ + "static/img/logo.53501ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ts-img/logo.png
// module id = 1EOz
// module chunks = 1